module.exports = __webpack_public_path__ + "img/salvar.e629e165.svg";